import { CustomSnackbar, severityType } from '@/utils/alert'
import { formataDataEmDDMMYYYYHM } from '@/utils/formatDateTo'
import { IconButton, Divider, Button } from '@mui/material'
import styles from './Feedback.module.css'
import { useEffect, useState } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
//import { api } from "./api";
import {api} from "../../../../services/api/api"
import {clientHost} from "../../../../services/api/api"
import attendanceApi from '@/services/api/attendance';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useClient } from '@/contexts/ClientContext';
import { getButtonColor } from "@/utils/degradeBotoes";

interface FeedbackProps {
    idAtendimento: number
}

export function Feedback({ idAtendimento }: FeedbackProps) {
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState<{
        severity: severityType
        message: string
    }>({ severity: 'success', message: '' })
    const [expanded, setExpanded] = useState({ geral: false, feedback: false });
    const [estado, setEstado] = useState('')
    const [atualizarEstado, setAtualizarEstado] = useState('')
    const [feedbackCliente, setFeedbackCliente] = useState({
        mensagem: '',
        avaliacaoRecomendacao: 0,
        avaliacaoMontagem: 0
    })
    const clientContext = useClient()
    const isFeedback = estado === 'Venda Concluída'

    async function buscarAtendimento() {
        try {
            const resposta = await attendanceApi.getAttendance(idAtendimento)
            const data = resposta.data
            setAtualizarEstado(data.atualizadoEm)
            setEstado(data.estado)
            setFeedbackCliente({
                mensagem: data.mensagem_feedback,
                avaliacaoRecomendacao: data.feedback_avalicacao_recomendacao,
                avaliacaoMontagem: data.feedback_avaliacao_montagem
            })
        } catch (err) {
            setAlertInfo({
                severity: 'error',
                message: 'Erro ao buscar atendimento.',
            });
            setShowAlert(true);
        }
    }

    async function concluirEtapa(tipo: string) {
        try {
            if (tipo === 'Feedback') {
                await attendanceApi.atualizarEstadoAtendimento(idAtendimento.toString(), 'Venda Concluída')
            } else {
                await attendanceApi.atualizarEstadoAtendimento(idAtendimento.toString(), tipo)
            }
            await buscarAtendimento()
            clientContext.reloadClientes();
            setAlertInfo({ severity: 'success', message: 'Etapa concluída!' });
            setShowAlert(true);
        } catch (err) {
            setAlertInfo({
                severity: 'error',
                message: 'Erro ao concluir etapa.',
            });
            setShowAlert(true);
        }
    }

    async function getToken() {
        const response = await api.get("/feedback/getTemporaryToken")
        return response.data
    }

    async function getFeedbackLink() {
        const temporaryToken = await getToken();
        const linkGerado = `${clientHost}/feedback?atendimento=${idAtendimento}&tk=${temporaryToken}`
        console.log(`http:/localhost:5174/feedback?atendimento=${idAtendimento}&tk=${temporaryToken}`)
        return linkGerado.replace("proposta", "feedback")
        
    }

    async function clipboardLink() {
        try {
            await navigator.clipboard.writeText(await getFeedbackLink());
            console.log("Texto copiado para area de transferencia!");
        } catch (err) {
            console.error("Erro ao copiar para area de transferencia:", err);
        }
    }

    function handleAlertClose() {
        setShowAlert(false)
    }


    function togglspread(section: keyof typeof expanded) {
        setExpanded((prev) => ({ ...prev, [section]: !prev[section] }));
    }

    useEffect(() => {
        buscarAtendimento()
    }, [])

    return (
        <>
            {expanded.geral ? (
                <>
                    <CustomSnackbar
                        open={showAlert}
                        severity={alertInfo.severity}
                        message={alertInfo.message}
                        handleClose={handleAlertClose}
                    />
                    <>
                        <div className={styles.cabecalho_container}>
                            <div className={`${styles.cabecalho} ${(isFeedback) && styles.cabecalho_ok}`}>
                                {isFeedback ? (
                                    <CheckCircleIcon className={styles.etapa_concluida} />
                                ) : (
                                    <RadioButtonUncheckedIcon
                                    />
                                )}


                                <div className={styles.titulo_info}>
                                    <h4>Feedback</h4>

                                    {(atualizarEstado !== '' && isFeedback) && (
                                        <span>
                                            Útima modificação {formataDataEmDDMMYYYYHM(new Date(atualizarEstado))}
                                        </span>
                                    )}

                                </div>

                            </div>

                            <div className={''}>
                                <IconButton onClick={() => togglspread('geral')}>
                                    <ExpandLessIcon fontSize='large' />
                                </IconButton>
                            </div>
                        </div>

                        <Divider style={{ marginBottom: '1rem' }} />
                    </>

                    <div className={styles.formulario_feedback_container}>
                        <div className={`${styles.feedback_container} ${(isFeedback) && styles.estado_feedback_container}`}>
                            <div className={styles.cabecalho}>
                                <div className={styles.titulo}>
                                    {isFeedback ? (<CheckCircleIcon />) : (<RadioButtonUncheckedIcon />)}

                                    <div className={styles.titulo_info}>

                                        <h4>{clientContext.client.dadosPessoais.nome}</h4>
                                    </div>
                                </div>

                                <div className={`${styles.acao_toggle} ${(isFeedback) ? styles.acao_toggle_feedback : ''}`}>
                                    <Button
                                        startIcon={<CheckCircleIcon />}
                                        className={styles.concluir_etapa}
                                        onClick={() => concluirEtapa('Feedback')}
                                        disabled={isFeedback}
                                    >
                                        {(isFeedback) ? 'ETAPA CONCLUIDA' : 'CONCLUIR ETAPA'}
                                    </Button>

                                    

                                    <div className={''}>
                                        {expanded.feedback ? (
                                            <IconButton onClick={() => togglspread('feedback')}>
                                                <ExpandLessIcon fontSize='large' />
                                            </IconButton>
                                        ) :
                                            <IconButton onClick={() => togglspread('feedback')}>
                                                <ExpandMoreIcon fontSize='large' />
                                            </IconButton>
                                        }
                                    </div>
                                </div>
                            </div>

                            <Divider style={{ marginBottom: '3rem', }} />


                            {expanded.feedback && (
                                <>
                                    <Button
                                        startIcon={<ContentCopyIcon />}
                                        className={styles.concluir_etapa}
                                        onClick={() => clipboardLink()}
                                        disabled={false}
                                    >
                                        COPIAR LINK PARA FORMULARIO
                                    </Button>
                                    <Divider style={{ margin: '1rem', }} />
                                    {!isFeedback ? (
                                        <span className={styles.mensagem}>Necessário concluir etapa para o cliente poder realizar seu feedback</span>
                                    ) : (
                                        <div className={styles.mensagem_feedback}>
                                            <div className={styles.avaliacao}>
                                                <span>Em uma escala de <span className={styles.valorBaixo}>1</span> a <span className={styles.valorAlto}>10</span>, o quanto você recomendaria a nossa <span style={{color:"#666CFF", fontWeight:"bold"}}>JORNADA DE ATENDIMENTO</span> para um amigo ou familiar?</span>
                                                <div className={styles.resposta}> Resposta: <span style={{width:"32px", height:"32px", display:"inline-flex", alignItems: "center", justifyContent:"center",borderRadius:"50%",color:"white", fontSize:"14px",fontWeight:"bold",backgroundColor: getButtonColor(feedbackCliente.avaliacaoMontagem)}} >{feedbackCliente.avaliacaoRecomendacao}</span></div>
                                            </div>

                                            <div className={styles.avaliacao}>
                                                <span>Em uma escala de <span className={styles.valorBaixo}>1</span> a <span className={styles.valorAlto}>10</span>, como você avalia a <span style={{color:"#666CFF", fontWeight:"bold"}}>MONTAGEM DOS MÓVEIS?</span></span>
                                                <div className={styles.resposta}> Resposta: <span style={{width:"32px", height:"32px", display:"inline-flex", alignItems: "center", justifyContent:"center",borderRadius:"50%",color:"white", fontSize:"14px",fontWeight:"bold",backgroundColor: getButtonColor(feedbackCliente.avaliacaoMontagem)}} >{feedbackCliente.avaliacaoMontagem}</span></div>
                                            </div>

                                            <div className={styles.avaliacao}>
                                                <span className={styles.titulo}>Qual sugestão você daria para elevarmos a exelência no atendimento aos nossos clientes?</span>
                                                <div className={styles.resposta}>{feedbackCliente.mensagem}</div>
                                            </div>
                                        </div>
                                    )}
                                </>

                            )}
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className={styles.cabecalho_container}>
                        <div className={styles.cabecalho}>
                            {isFeedback ? (
                                <CheckCircleIcon className={styles.etapa_concluida} />
                            ) : (
                                <RadioButtonUncheckedIcon
                                />
                            )}

                            <div className={styles.titulo_info}>
                                <h4>Feedback</h4>

                                {(atualizarEstado !== '' && (isFeedback)) && (
                                    <span>
                                        Útima modificação {formataDataEmDDMMYYYYHM(new Date(atualizarEstado))}
                                    </span>
                                )}

                            </div>
                        </div>

                        <div className={''}>
                            {isFeedback && (
                                <span className={styles.processo_concluido}>Processo concluído</span>
                            )}
                            <IconButton onClick={() => togglspread('geral')}>
                                <ExpandMoreIcon fontSize='large' />
                            </IconButton>
                        </div>
                    </div>

                    <Divider style={{ marginTop: '1rem' }} />
                </>
            )
            }
        </>
    )
}